import { SongListType } from '../../../../../common/src/model.ts';
import { Calendar } from './calendar.tsx';

export function EventCalendar() {
  return <Calendar songListType={SongListType.Event} />;
}
